import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getMonitoringSummary } from 'features/admin-monitoring/command-center/async';
import { TimeWindowPreset } from 'features/admin-monitoring/command-center/timeWindow';
import { CommandCenterState } from 'features/admin-monitoring/command-center/types';
import {
  fulfilled,
  initialRequestState,
  pending,
  rejected,
  requestReducer,
} from 'features/shared/request';

export const initialState: CommandCenterState = {
  summary: { data: undefined, request: initialRequestState },
  timeWindow: TimeWindowPreset.Day,
};

const slice = createSlice({
  name: 'monitoringCommandCenter',
  initialState,
  reducers: {
    setTimeWindow: (state, { payload }: PayloadAction<TimeWindowPreset>) => {
      state.timeWindow = payload;
    },
    resetSummary: (state) => {
      state.summary = initialState.summary;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMonitoringSummary.pending, (state, { meta }) => {
      state.summary.data = undefined;
      state.summary.request = requestReducer(
        state.summary.request,
        pending({ meta })
      );
    });
    builder.addCase(
      getMonitoringSummary.fulfilled,
      (state, { meta, payload }) => {
        if (state.summary.request.id === meta.requestId) {
          state.summary.data = payload;
          state.summary.request = requestReducer(
            state.summary.request,
            fulfilled({ meta })
          );
        }
      }
    );
    builder.addCase(getMonitoringSummary.rejected, (state, { meta }) => {
      state.summary.request = requestReducer(
        state.summary.request,
        rejected({ meta })
      );
    });
  },
});

export const { setTimeWindow, resetSummary } = slice.actions;

const { reducer } = slice;

export default reducer;
